import { TPAComponentProps } from '../../types';

export interface StripCardProps extends TPAComponentProps {
  media?: React.ReactNode;
  info?: React.ReactNode;
  roundMedia?: boolean;
  sidePadding?: boolean;
}

export interface StripCardDefaultProps {
  roundMedia: boolean;
  sidePadding: boolean;
}
